import { AnalyticsEvents, trackEvent } from "@axqora/analytics";
import { useAppStoreHref } from "@axqora/ui";
import type { Locale } from "../content/types";
import { luxoriaConfig } from "../config";

type ComingSoonCTAProps = {
  label: string;
  locale: Locale;
  page: string;
  fullWidth?: boolean;
};

/**
 * Primary CTA. Links to the App Store and fires a `cta_click` analytics event.
 */
export function ComingSoonCTA({ label, locale, page, fullWidth }: ComingSoonCTAProps) {
  const base =
    "inline-flex items-center justify-center gap-2 rounded-full bg-accent-blue px-6 py-3.5 text-[15px] font-semibold text-on-accent shadow-cta transition-transform hover:-translate-y-0.5";
  const width = fullWidth ? "w-full" : "";
  const href = useAppStoreHref(luxoriaConfig.appStoreUrl[locale], locale);

  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      className={`${base} ${width}`}
      onClick={() =>
        trackEvent(AnalyticsEvents.CtaClick, {
          product: "luxoria",
          page,
          locale,
          target: "app_store"
        })
      }
    >
      {label}
    </a>
  );
}
